import React from 'react';
import { bindActionCreators } from 'redux';
import { browserHistory } from "react-router";
import { connect } from 'react-redux';

import * as facebookActions from '../../../actions/facebook'
import { trans } from '../../../localization/language'

class Facebook extends React.Component {

	handleClick(){
		browserHistory.push('/fbSecurity/facebookConnect/init');
	}

	render(){
		return (
			<a href="#" className="aside-nav__link" onClick={this.handleClick.bind(this)}>
				<div className="aside-nav__item">
					<div className="aside-nav__icon--facebook"></div>
					<div className="aside-nav__txt">
						{trans('connect_action')} {trans('facebook')}
					</div>
				</div>
			</a>
		)
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(Object.assign({}, facebookActions), dispatch)
}

export default connect(null, mapDispatchToProps)(Facebook);



// WEBPACK FOOTER //
// ./app/components/security/action_panel/Facebook.js